import { useEffect } from 'react';
import axios from 'axios';
import * as CookieConsent from 'vanilla-cookieconsent';
import { setMatomoRuntimeConfig, syncMatomoWithConsent } from '../lib/matomo';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Charge la config Matomo depuis l'API (MongoDB) puis synchronise avec le consentement cookies.
 */
const MatomoConfigLoader = () => {
  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/matomo-config`);
        if (cancelled) return;
        setMatomoRuntimeConfig(data || { enabled: false });
      } catch {
        if (cancelled) return;
        setMatomoRuntimeConfig({ enabled: false });
      }
      if (!cancelled) {
        syncMatomoWithConsent(CookieConsent.acceptedCategory('analytics'));
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default MatomoConfigLoader;
